import { render, staticRenderFns } from "./KinvaDocCrud.vue?vue&type=template&id=b9bd01c0"
import script from "./KinvaDocCrud.vue?vue&type=script&lang=js"
export * from "./KinvaDocCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports